"use client";

import { ChevronDownIcon } from "@/components/event-detail/chevron-down-icon";
import SourceRect from "@/events/crypto/source-rect";
import { useParseText } from "@/hooks/useParseText";
import { cn } from "@/lib/utils";
import { get } from "@/utils/utils";
import { useMemo, useState } from "react";

interface RulesSectionProps {
    event: any;
    className?: string;
    showSourceRect?: boolean;
}

export function RulesSection( { event, className, showSourceRect = false }: RulesSectionProps ) {
    const [ isExpanded, setIsExpanded ] = useState( false );
    const rules = useMemo( () => {
        return get( event, "rules", "" );
    }, [ event ] );
    const { renderParts } = useParseText( rules );
    const originLink = get( event, "originLink", undefined );

    const sourceRectElement = showSourceRect && originLink
        ? (
            <div className="mt-2">
                {/* SourceRect will be injected here by parent */}
                <SourceRect originLink={originLink} />
            </div>
        )
        : null;

    if ( !rules && !showSourceRect ) return null;

    return (
        <div
            className={cn(
                "mt-3 rounded-xl border border-stroke bg-surface-card p-3",
                !isExpanded && "h-12",
                className,
            )}
        >
            {rules && (
                <>
                    <button
                        type="button"
                        onClick={() => setIsExpanded( !isExpanded )}
                        className="flex w-full items-center justify-between gap-2 text-left"
                    >
                        <h2 className="text-[16px] font-bold leading-normal text-t1">Rules</h2>
                        <span className="flex shrink-0">
                            <ChevronDownIcon
                                className={cn(
                                    "size-6 text-t3 transition-transform duration-200",
                                    isExpanded && "rotate-180",
                                )}
                            />
                        </span>
                    </button>

                    <div
                        className={cn(
                            "overflow-hidden transition-all duration-200",
                            isExpanded ? "max-h-[1000px] opacity-100 mt-2" : "max-h-0 opacity-0",
                        )}
                    >
                        <p className="text-[14px] font-medium leading-normal text-t2">{renderParts()}</p>
                        {sourceRectElement}
                    </div>
                </>
            )}
        </div>
    );
}
